module.exports = __webpack_public_path__ + "img/6900cc810305625673c7a06241493ba8.png";